import { ImportExport } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import React from "react";
import store from "src/store";
import { useStepIndex } from "./step-index-context";

export default function SkipStep() {
  var stepIndex=useStepIndex()
    const updateSkipStatus = async (value) => {
        store.steps[stepIndex]['skip'] = value;
        store.updateStore();
    }

    store.useRerenderIfChange(() => [
        store.steps[stepIndex]['skip']
    ]);


    let skip = store.steps[stepIndex]['skip'];

    return (
        <div css="background: white;display: flex;margin-left:10px;padding-top:10px;">
            <div css={`width:110px;flex-shrink:0;`}>
                Skip
            </div>
            <div css={`flex-grow:1;`}>
            {skip ?
                <span css="font-weight: 700">Step  is skipped</span> : <span css="font-weight: 700">Step is executed</span>
            }
            &nbsp;
            {
                !store.isStepReadOnly(stepIndex) &&
                <span css={`
                    color:#799fd4;
                    cursor: pointer;
                    font-size:13px;
                    text-decoration-line: underline;
                    justify-self: right;
                    font-weight:100;
                `}
                  onClick={() => {
                        store.removeResults()
                        updateSkipStatus(!skip)
                  }}>Change</span>
            }
            </div>
        </div>
    )
}